/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Org_Team_CreatedInputs */

const th_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`สร้างทีมแล้ว`)
};

const en_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team created.`)
};

const ja_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`チームを作成しました。`)
};

const zh_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球队已创建。`)
};

const es_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Equipo creado.`)
};

const pt_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Time criado.`)
};

const id_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tim dibuat.`)
};

const fr_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Équipe créée.`)
};

const tl_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nagawa ang team.`)
};

const vi_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Đã tạo đội.`)
};

const ko_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`팀을 만들었습니다.`)
};

const de_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team angelegt.`)
};

const ru_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команда создана.`)
};

const tr_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Takım oluşturuldu.`)
};

const it_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Squadra creata.`)
};

const pl_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Drużyna utworzona.`)
};

const uk_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Команду створено.`)
};

const hi_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`टीम बन गई।`)
};

const ar_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`أُنشئ الفريق.`)
};

const ms_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pasukan dicipta.`)
};

const bn_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`দল তৈরি হয়েছে।`)
};

const zh_tw2_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊已建立。`)
};

const zh_hk2_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`球隊已建立。`)
};

const ur_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ٹیم بن گئی۔`)
};

const fa_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تیم ساخته شد.`)
};

const sw_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Timu imefunguliwa.`)
};

const nl_org_team_created = /** @type {(inputs: Org_Team_CreatedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Team aangemaakt.`)
};

/**
* | output |
* | --- |
* | "Team created." |
*
* @param {Org_Team_CreatedInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const org_team_created = /** @type {((inputs?: Org_Team_CreatedInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Org_Team_CreatedInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_org_team_created(inputs)
	if (locale === "ja") return ja_org_team_created(inputs)
	if (locale === "zh") return zh_org_team_created(inputs)
	if (locale === "es") return es_org_team_created(inputs)
	if (locale === "pt") return pt_org_team_created(inputs)
	if (locale === "id") return id_org_team_created(inputs)
	if (locale === "fr") return fr_org_team_created(inputs)
	if (locale === "tl") return tl_org_team_created(inputs)
	if (locale === "vi") return vi_org_team_created(inputs)
	if (locale === "ko") return ko_org_team_created(inputs)
	if (locale === "de") return de_org_team_created(inputs)
	if (locale === "ru") return ru_org_team_created(inputs)
	if (locale === "tr") return tr_org_team_created(inputs)
	if (locale === "it") return it_org_team_created(inputs)
	if (locale === "pl") return pl_org_team_created(inputs)
	if (locale === "uk") return uk_org_team_created(inputs)
	if (locale === "hi") return hi_org_team_created(inputs)
	if (locale === "ar") return ar_org_team_created(inputs)
	if (locale === "ms") return ms_org_team_created(inputs)
	if (locale === "bn") return bn_org_team_created(inputs)
	if (locale === "zh-TW") return zh_tw2_org_team_created(inputs)
	if (locale === "zh-HK") return zh_hk2_org_team_created(inputs)
	if (locale === "ur") return ur_org_team_created(inputs)
	if (locale === "fa") return fa_org_team_created(inputs)
	if (locale === "sw") return sw_org_team_created(inputs)
	if (locale === "nl") return nl_org_team_created(inputs)
	return en_org_team_created(inputs)
});